import { HeaderMenuItem } from "@shetharp/gatsby-theme-polaroid";

export const headerMenuItems: HeaderMenuItem[] = [
  {
    label: "Home",
    slug: "/",
    isVisibleLaptop: false,
  },
  {
    label: "Blog",
    slug: "/blog",
  },
  {
    label: "Readme",
    slug: "/readme",
    isVisibleLaptop: false,
  },
  {
    label: "About",
    slug: "/about",
    isVisibleLaptop: false,
  },
  {
    label: "Contact",
    slug: "/contact",
    isVisibleLaptop: false,
  },
  {
    label: "LinkedIn",
    href: "https://linkedin.com/in/shetharp",
  },
  {
    label: "Instagram",
    href: "https://instagram.com/shetharp",
  },
  {
    label: "Colophon",
    slug: "/colophon",
  },
];
